// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KfOO","questions":"styles_questions__5Fp-I","footer":"styles_footer__5vkJ-"};